import React from "react"
import Echart from "echarts-for-react"
import { boxplotVerticalStore } from "@/routes/apt/[apt_code]/statistics/_components/boxplot/boxplot-vertical-store"
import { statsStore } from "../../stats-store"
import { langStore } from "@/stores/lang-store"
import useIsMobile from "@/hooks/use-is-mobile"
import { summaryStore } from "../summary/summary-store"
import { boxplotBundle } from "./boxplot-const"

const BoxplotVertical = ({ title = "수도 사용량 분포", className = "", axisMax }) => {
  const isMobile = useIsMobile()
  const { unit } = statsStore()
  const { lang } = langStore()

  const { boxplotSeries, scatterSeries, color } = boxplotVerticalStore()
  const { selectedKey } = summaryStore()
  const xAxisData = selectedKey === "ALL" ? boxplotBundle.all[lang] : selectedKey

  const series = [scatterSeries, boxplotSeries]
  const option = {
    grid: {
      top: isMobile ? 60 : 80,
      left: 20,
      right: isMobile ? 10 : 50,
      bottom: 30
    },
    title: { text: title },
    tooltip: {
      trigger: "item",
      borderColor: color,
      formatter: (p) => {
        if (p.seriesType === "custom") {
          const [min, q1, med, q3, max] = p.data
          const t = boxplotBundle.stats

          return `
            <div style="padding:0px 8px;">
              <b>${p.name} ${t.title[lang]}</b>(${unit})<br/>
              ${t.max[lang]}: ${max}<br/>
              ${t.q3[lang]}: ${q3}<br/>
              ${t.median[lang]}: ${med}<br/>
              ${t.q1[lang]}: ${q1}<br/>
              ${t.min[lang]}: ${min}
            </div>
          `
        }

        if (p.seriesType === "scatter") {
          return `
            ${p.name} ${boxplotBundle.stats.outlier[lang]}<br/>
            ${p.data[2]}: <b>${p.data[1]}</b> ${unit}
          `
        }

        return ""
      }
    },
    xAxis: {
      type: "category",
      data: [xAxisData]
    },
    yAxis: {
      type: "value",
      max: axisMax,
      position: isMobile ? "left" : "right", // INFO: Y축을 오른쪽에 배치
      splitLine: { lineStyle: { type: "dashed" } }
    },
    series
  }

  return (
    <section className={`${className}`}>
      <Echart
        style={{
          width: "100%",
          height: "100%"
        }}
        option={option}
        notMerge
        autoResize
      />
    </section>
  )
}

export default BoxplotVertical
